import * as React from 'react';
import React__default from 'react';
import { s as styleInject } from '../style-inject.es-9fb3b5d8.js';
import * as imageKit from '@wix/image-kit';
import { fittingTypes, alignTypes, getData, isWEBP } from '@wix/image-kit';
import fastdom from 'fastdom';
import MediaItemErrorMsg from './MediaItemErrorMsg.js';
import 'classnames';
import 'wix-rich-content-common';
import 'wix-rich-content-common/libs/Tooltip';
import '../Icons/ErrorIcon.js';

var css_248z = ".pVbib{display:block;height:100%;width:100%}.pVbib img{max-width:var(--wix-img-max-width,100%)}.pVbib[data-animate-blur] img{filter:blur(9px);transition:filter .8s ease-in}.pVbib[data-animate-blur] img[data-load-done]{filter:none}";
var styles = {"image":"pVbib"};
styleInject(css_248z);

const { STATIC_MEDIA_URL: STATIC_MEDIA_URL$1 } = imageKit;
const fetchLQIP = ({ fittingType, src, target, options, }) => {
    const placeholder = imageKit.getPlaceholder(fittingType, src, target, {
        ...options,
        autoEncode: true,
    });
    if (placeholder?.uri && !/^[a-z]+:/.test(placeholder.uri)) {
        placeholder.uri = `${STATIC_MEDIA_URL$1}${placeholder.uri}`;
    }
    return placeholder;
};
const SCHEME_RE = /^[a-z]+:/;
const Image$1 = (props) => {
    const { id, containerId, uri, alt, name = '', role, width, height, displayMode, devicePixelRatio, quality, alignType, bgEffectName = '', focalPoint, upscaleMethod, className = '', crop, imageStyles = {}, targetWidth, targetHeight, targetScale, onLoad = () => { }, onError = () => { }, shouldUseLQIP, containerWidth, containerHeight, getPlaceholder, isInFirstFold, placeholderTransition, socialAttrs, isSEOBot, skipMeasure, lazyLoadImgExperimentOpen, hasAnimation, allowWEBPTransform, } = props;
    const imageRef = React.useRef(null);
    // fix containerId and id to support hoverBox component
    let hasSsrSrc = '';
    const hasBlurTransition = placeholderTransition === 'blur';
    const ssrImageData = React.useRef(null);
    if (!ssrImageData.current) {
        if (getPlaceholder || shouldUseLQIP || isInFirstFold || isSEOBot) {
            const options = {
                upscaleMethod,
                ...(quality ? quality : {}),
                shouldLoadHQImage: isInFirstFold,
                isSEOBot,
                hasAnimation,
                allowWEBPTransform,
            };
            ssrImageData.current = (getPlaceholder || fetchLQIP)({
                fittingType: displayMode,
                src: {
                    id: uri,
                    width,
                    height,
                    crop,
                    name,
                    focalPoint,
                },
                target: {
                    width: containerWidth,
                    height: containerHeight,
                    alignment: alignType,
                    htmlTag: 'img',
                },
                options,
            });
            hasSsrSrc =
                !ssrImageData.current.transformed || isInFirstFold || isSEOBot
                    ? ''
                    : 'true';
        }
        else {
            // to keep an empty placeholder data
            ssrImageData.current = {
                uri: undefined,
                css: { img: {} },
                attr: { img: {}, container: {} },
                transformed: false,
            };
        }
    }
    const isLQIP = !isSEOBot &&
        (getPlaceholder || shouldUseLQIP) &&
        !isInFirstFold &&
        ssrImageData.current.transformed;
    const imageInfo = React.useMemo(() => JSON.stringify({
        containerId,
        ...(containerId && { containerId }),
        ...(alignType && { alignType }),
        ...(skipMeasure && { skipMeasure: true }),
        displayMode,
        ...(containerWidth && { targetWidth: containerWidth }),
        ...(containerHeight && { targetHeight: containerHeight }),
        ...(targetWidth && { targetWidth }),
        ...(targetHeight && { targetHeight }),
        ...(targetScale && { targetScale }),
        isLQIP,
        isSEOBot,
        lqipTransition: placeholderTransition,
        imageData: {
            width,
            height,
            uri,
            name,
            displayMode,
            hasAnimation,
            ...(quality && { quality }),
            ...(devicePixelRatio && { devicePixelRatio }),
            ...(focalPoint && { focalPoint }),
            ...(crop && { crop }),
            ...(upscaleMethod && { upscaleMethod }),
        },
    }), [
        containerId,
        alignType,
        skipMeasure,
        displayMode,
        containerHeight,
        containerWidth,
        targetWidth,
        targetHeight,
        targetScale,
        isLQIP,
        isSEOBot,
        placeholderTransition,
        width,
        height,
        uri,
        name,
        quality,
        devicePixelRatio,
        focalPoint,
        crop,
        upscaleMethod,
        hasAnimation,
    ]);
    const ssrResult = ssrImageData.current;
    const src = ssrResult?.uri;
    const srcset = ssrResult?.srcset;
    const placeholderStyle = ssrResult.css?.img;
    const classNames = `${styles.image} ${className}`;
    React.useEffect(() => {
        // When image comes from cache onLoad not trigger on native HTML element
        const imgElment = imageRef.current;
        if (onLoad && imgElment?.currentSrc && imgElment?.complete) {
            onLoad({
                target: imageRef.current,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const maxWidth = ssrResult && !ssrResult?.transformed
        ? `max(${width}px, 100%)`
        : targetWidth
            ? `${targetWidth}px`
            : null;
    return (React.createElement("wow-image", { id: id, class: classNames, "data-image-info": imageInfo, "data-bg-effect-name": bgEffectName, "data-has-ssr-src": hasSsrSrc, "data-animate-blur": !isSEOBot && isLQIP && hasBlurTransition ? '' : undefined, style: maxWidth ? { '--wix-img-max-width': maxWidth } : {} },
        React.createElement("img", { src: src, ref: imageRef, alt: alt || '', role: role, style: { ...placeholderStyle, ...imageStyles }, onLoad: onLoad, onError: onError, ...(containerWidth && { width: containerWidth }), ...(containerHeight && { height: containerHeight }), ...socialAttrs, ...(isInFirstFold
                ? {
                    srcSet: srcset?.dpr
                        ?.map((s) => SCHEME_RE.test(s) ? s : `${STATIC_MEDIA_URL$1}${s}`)
                        .join(', '),
                    fetchpriority: 'high',
                }
                : lazyLoadImgExperimentOpen
                    ? { loading: 'lazy' }
                    : {}) })));
};

const CSS_NUMERIC_VALUES = {
    columnCount: 1,
    columns: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    zIndex: 1,
    zoom: 1,
};
const pick = (obj, props) => {
    const propsArr = Array.isArray(props) ? props : [props];
    return propsArr.reduce((subObj, prop) => {
        const val = obj[prop];
        return val !== undefined ? Object.assign(subObj, { [prop]: val }) : subObj;
    }, {});
};
const addDefaultUnitIfNeeded = (prop, value) => typeof value === 'number' &&
    !CSS_NUMERIC_VALUES[prop]
    ? `${value}px`
    : value;
const setStyle = (node, styleProperties) => node &&
    styleProperties &&
    Object.keys(styleProperties).forEach((prop) => {
        const propValue = styleProperties[prop];
        if (propValue !== undefined) {
            node.style[prop] = addDefaultUnitIfNeeded(prop, propValue);
        }
        else {
            node.style.removeProperty(prop);
        }
    });
const getScreenHeight = (heightOverride) => heightOverride ||
    document.documentElement.clientHeight ||
    window.innerHeight ||
    0;
const getImageComputedProperties = (extendedImageInfo, envConsts, htmlTag, allowWEBPTransform) => {
    // todo: CLNT-5323 , wixapp sildergallery proxy is generating image data without uri
    if (!extendedImageInfo.targetWidth ||
        !extendedImageInfo.targetHeight ||
        !extendedImageInfo.imageData.uri) {
        return { uri: '', css: {}, transformed: false };
    }
    const { imageData } = extendedImageInfo;
    const fittingType = extendedImageInfo.displayMode || fittingTypes.SCALE_TO_FILL;
    const imageOptions = Object.assign(pick(imageData, ['upscaleMethod', 'hasAnimation']), pick(extendedImageInfo, 'filters'), extendedImageInfo.quality || imageData.quality, allowWEBPTransform && { allowWEBPTransform });
    const devicePixelRatioFromData = extendedImageInfo.imageData.devicePixelRatio || envConsts.devicePixelRatio;
    const devicePixelRatio = getDevicePixelRatio$1(devicePixelRatioFromData);
    const src = Object.assign(pick(imageData, ['width', 'height', 'crop', 'name', 'focalPoint']), { id: imageData.uri });
    const target = {
        width: extendedImageInfo.targetWidth,
        height: extendedImageInfo.targetHeight,
        htmlTag: (htmlTag || 'img'),
        pixelAspectRatio: devicePixelRatio,
        alignment: extendedImageInfo.alignType || alignTypes.CENTER,
    };
    const imageComputedProperties = getData(fittingType, src, target, imageOptions);
    imageComputedProperties.uri = getMediaUrlByContext(imageComputedProperties.uri, envConsts.staticMediaUrl, envConsts.mediaRootUrl);
    return imageComputedProperties;
};
const getMediaUrlByContext = (imageUri, staticMediaUrl, mediaRootUrl) => {
    const isExternalUrl = /(^https?)|(^data)|(^blob)|(^\/\/)/.test(imageUri);
    if (isExternalUrl) {
        return imageUri;
    }
    let path = `${staticMediaUrl}/`;
    if (imageUri) {
        if (/^micons\//.test(imageUri)) {
            path = mediaRootUrl;
        }
        else if (/[^.]+$/.exec(imageUri)?.[0] === 'ico') {
            // if the image is an icon then it's taken from a slightly different place
            path = path.replace('media', 'ficons');
        }
    }
    return path + imageUri;
};
const getDevicePixelRatio$1 = (devicePixelRatio) => {
    // we should be able to force devicePixelRatio from url by using the query param -
    const queryParams = window.location.search
        .split('&')
        .map((query) => query.split('='));
    const devicePixelRatioQueryParam = queryParams.find((query) => query[0].toLowerCase().includes('devicepixelratio'));
    const devicePixelRatioValueForceFromUrl = devicePixelRatioQueryParam
        ? Number(devicePixelRatioQueryParam[1])
        : null;
    return devicePixelRatioValueForceFromUrl || devicePixelRatio || 1;
};
const getImageSrc = (imageNode) => imageNode.getAttribute('src');
const isTransformedWEBP = (imageNode, imageUri) => {
    const src = getImageSrc(imageNode) || '';
    const isTransformed = !!src.match(/.webp\/v1\//);
    return isWEBP(imageUri) && isTransformed;
};

const MOBILE_SAFE_ADDRESSBAR_HEIGHT = 80;
function getHeightOverride(height, mediaHeightOverrideType) {
    // on mobile, documentElement.clientHeight changes when scrolling, because of address bar collapsing.
    // avoiding re-fetching image by returning the same height
    return mediaHeightOverrideType === 'fixed' ||
        mediaHeightOverrideType === 'viewport'
        ? document.documentElement.clientHeight + MOBILE_SAFE_ADDRESSBAR_HEIGHT
        : height;
}
function computeScaleOverrides(imageStyle, targetScale = 1) {
    return targetScale !== 1
        ? {
            ...imageStyle,
            width: '100%',
            height: '100%',
        }
        : imageStyle;
}
/**
 * compute specific overrides
 */
function computeStyleOverrides(mediaHeightOverrideType, imageStyle, displayMode, targetScale, isResponsive) {
    // image scaling override
    const styleWithScale = computeScaleOverrides(imageStyle, targetScale);
    if (isResponsive) {
        delete styleWithScale.height;
        styleWithScale.width = '100%';
    }
    if (!mediaHeightOverrideType) {
        return styleWithScale;
    }
    // siteBackground on mobile
    const style = { ...styleWithScale };
    if (displayMode === 'fill') {
        style.position = 'absolute';
        style.top = '0';
    }
    else if (displayMode === 'fit') {
        style.height = '100%';
    }
    if (mediaHeightOverrideType === 'fixed') {
        // eliminates white gap when address bar is collapsing
        style['will-change'] = 'transform';
    }
    // force image alignment to include top
    if (style.objectPosition) {
        style.objectPosition = imageStyle.objectPosition.replace(/(center|bottom)$/, 'top');
    }
    return style;
}
function getSourceSetsTargetHeightByEffect(sourceSets, offsetWidth, offsetHeight, screenHeight, services) {
    const sourceSetsTargetHeights = {};
    sourceSets.forEach(({ mediaQuery, scrollEffect }) => {
        sourceSetsTargetHeights[mediaQuery] = services.getMediaDimensionsByEffect(scrollEffect, offsetWidth, offsetHeight, screenHeight).height;
    });
    return sourceSetsTargetHeights;
}
function computeSrcSets(measures, imageInfo, envConsts) {
    const { sourceSets } = imageInfo;
    if (!sourceSets || !sourceSets.length) {
        return;
    }
    const mediaToUri = {};
    sourceSets.forEach(({ mediaQuery, crop, focalPoint }) => {
        const imageInfoClone = {
            ...imageInfo,
            targetHeight: (measures.sourceSetsTargetHeights || {})[mediaQuery] || 0,
            imageData: {
                ...imageInfo.imageData,
                crop,
                focalPoint,
            },
        };
        const imageComputedProperties = getImageComputedProperties(imageInfoClone, envConsts, 'img');
        mediaToUri[mediaQuery] = imageComputedProperties.uri || '';
    });
    return mediaToUri;
}
function measure(id, measures, domNodes, { containerElm, bgEffect = 'none', sourceSets, }, services) {
    const innerImage = domNodes.image;
    const wixImage = domNodes[id];
    const screenHeight = getScreenHeight(services.getScreenHeightOverride?.());
    // override positioning and scaling of image (SiteBackground mobile override behaviour)
    const mediaHeightOverrideType = containerElm?.dataset
        .mediaHeightOverrideType;
    const sourceOfDimensions = (containerElm && bgEffect && bgEffect !== 'none' ? containerElm : wixImage); // default to self
    const { width, height } = services.getMediaDimensionsByEffect?.(bgEffect, sourceOfDimensions.offsetWidth, sourceOfDimensions.offsetHeight, screenHeight) || {
        width: wixImage.offsetWidth,
        height: wixImage.offsetHeight,
    };
    if (sourceSets) {
        measures.sourceSetsTargetHeights = getSourceSetsTargetHeightByEffect(sourceSets, sourceOfDimensions.offsetWidth, sourceOfDimensions.offsetHeight, screenHeight, services);
    }
    if (!innerImage) {
        return;
    }
    const imgSrc = getImageSrc(innerImage);
    measures.width = width;
    measures.height = getHeightOverride(height, mediaHeightOverrideType);
    measures.screenHeight = screenHeight;
    measures.imgSrc = imgSrc;
    measures.boundingRect = wixImage.getBoundingClientRect();
    measures.mediaHeightOverrideType = mediaHeightOverrideType;
}
function patch(id, measures, domNodes, imageInfo, services, envConsts, loadImage, isResponsive, bgEffect) {
    if (!Object.keys(measures).length) {
        return;
    }
    const { imageData } = imageInfo;
    const wixImageNode = domNodes[id];
    const image = domNodes.image;
    // no retina scaling for background scroll effects
    if (bgEffect) {
        imageData.devicePixelRatio = 1;
    }
    const targetScale = imageInfo.targetScale || 1;
    const extendedImageInfo = {
        ...imageInfo,
        ...(!imageInfo.skipMeasure && {
            targetWidth: (measures.width || 0) * targetScale,
            targetHeight: (measures.height || 0) * targetScale,
        }),
        displayMode: imageData.displayMode,
    };
    // for TPAs that did not get specs.thunderbolt.allowWEBPTransformation in SSR & downloaded untransformed image, don't allow webp transformation
    const allowWEBPTransform = services.isExperimentOpen?.('specs.thunderbolt.allowWEBPTransformation') && isTransformedWEBP(image, imageData.uri);
    const imageComputedProperties = getImageComputedProperties(extendedImageInfo, envConsts, 'img', allowWEBPTransform);
    const computedStyle = imageComputedProperties?.css?.img || {};
    const imageStyle = computeStyleOverrides(measures.mediaHeightOverrideType, computedStyle, imageData.displayMode, targetScale, isResponsive);
    setStyle(image, imageStyle);
    const src = imageComputedProperties?.uri || '';
    wixImageNode.setAttribute('data-src', src);
    const mediaToUri = computeSrcSets(measures, extendedImageInfo, envConsts);
    // clear initial indication that the image src came from ssr render
    wixImageNode.setAttribute('data-has-ssr-src', '');
    if (imageInfo.isLQIP &&
        imageInfo.lqipTransition &&
        !('transitioned' in wixImageNode.dataset)) {
        wixImageNode.dataset.transitioned = '';
        if (image.complete) {
            image.onload = function () {
                image.dataset.loadDone = '';
            };
        }
        else {
            image.onload = function () {
                if (image.complete) {
                    image.dataset.loadDone = '';
                }
                else {
                    image.onload = function () {
                        image.dataset.loadDone = '';
                    };
                }
            };
        }
    }
    if (loadImage) {
        image.setAttribute('fetchpriority', 'high');
        image.currentSrc !== src && image.setAttribute('src', src);
        image.srcset && image.srcset !== src && image.setAttribute('srcset', src);
        if (domNodes.picture && extendedImageInfo.sourceSets) {
            Array.from(domNodes.picture.querySelectorAll('source')).forEach((sourceNode) => {
                const mediaQuery = sourceNode.media || '';
                const uri = mediaToUri ? mediaToUri[mediaQuery] : '';
                sourceNode.srcset !== uri && sourceNode.setAttribute('srcset', uri);
            });
        }
    }
}
var imageLayout = {
    measure,
    patch,
};

// @ts-nocheck
const TIMEOUT = 250;
const imageEffectMap = {
    parallax: 'ImageParallax',
    fixed: 'ImageReveal',
};
function wowImageFactory(services, environmentConsts, contextWindow) {
    return class WowImage extends contextWindow.HTMLElement {
        constructor() {
            // eslint-disable-line no-useless-constructor
            super();
            this.childListObserver = null;
            this.timeoutId = null;
        }
        attributeChangedCallback(_, oldValue) {
            if (oldValue) {
                this.reLayout();
            }
        }
        connectedCallback() {
            if (environmentConsts.disableImagesLazyLoading) {
                this.reLayout();
            }
            else {
                this.observeIntersect();
            }
        }
        disconnectedCallback() {
            this.unobserveResize();
            this.unobserveIntersect();
            this.unobserveChildren();
        }
        static get observedAttributes() {
            return ['data-image-info'];
        }
        reLayout() {
            const domNodes = {};
            const measures = {};
            const imageId = this.getAttribute('id');
            const imageInfo = JSON.parse(this.dataset.imageInfo || '');
            const isResponsive = this.dataset.isResponsive === 'true';
            const { bgEffectName } = this.dataset;
            const { scrollEffect } = imageInfo.imageData;
            const { sourceSets } = imageInfo;
            const bgEffect = bgEffectName || imageEffectMap[scrollEffect];
            if (sourceSets && sourceSets.length) {
                sourceSets.forEach((sourceSet) => {
                    if (sourceSet.scrollEffect) {
                        sourceSet.scrollEffect = imageEffectMap[sourceSet.scrollEffect];
                    }
                });
            }
            domNodes[imageId] = this;
            if (imageInfo.containerId) {
                domNodes[imageInfo.containerId] = contextWindow.document.getElementById(`${imageInfo.containerId}`);
            }
            const containerElm = imageInfo.containerId
                ? domNodes[imageInfo.containerId]
                : undefined;
            domNodes.image = this.querySelector('img');
            domNodes.picture = this.querySelector('picture');
            if (!domNodes.image) {
                // missing children, can't layout, wait for children to be created first
                const target = this;
                this.observeChildren(target);
                return;
            }
            // clean up
            this.unobserveChildren();
            // from now on just observe changes to children of top level
            this.observeChildren(this);
            services.mutationService.measure(() => {
                imageLayout.measure(imageId, measures, domNodes, {
                    containerElm,
                    bgEffect,
                    sourceSets,
                }, services);
            });
            const patchImage = (shouldLoadImage) => {
                services.mutationService.mutate(() => {
                    imageLayout.patch(imageId, measures, domNodes, imageInfo, services, environmentConsts, shouldLoadImage, isResponsive, bgEffect);
                });
            };
            // if image has no src or current src if from ssr render stage  -
            // load the image immediately, otherwise - debounce the reload
            if (!getImageSrc(domNodes.image) ||
                this.dataset.hasSsrSrc) {
                patchImage(true);
            }
            else {
                this.debounceImageLoad(patchImage);
            }
        }
        /**
         * Debounce consecutive image loads
         *
         * @param {function} patchImage closure for patching the image
         */
        debounceImageLoad(patchImage) {
            clearTimeout(this.timeoutId);
            this.timeoutId = contextWindow.setTimeout(() => {
                patchImage(true);
            }, TIMEOUT);
            patchImage(false);
        }
        observeResize() {
            services.resizeService?.observe(this);
        }
        unobserveResize() {
            services.resizeService?.unobserve(this);
        }
        observeIntersect() {
            services.intersectionService?.observe(this);
        }
        unobserveIntersect() {
            services.intersectionService?.unobserve(this);
        }
        /**
         * Observe DOM mutations to wait for addition of missing children
         *
         * @param {HTMLElement} parent
         */
        observeChildren(parent) {
            if (!this.childListObserver) {
                this.childListObserver = new contextWindow.MutationObserver(() => {
                    this.reLayout();
                });
            }
            this.childListObserver.observe(parent, { childList: true });
        }
        /**
         * Remove DOM MutationObserver if one was created
         */
        unobserveChildren() {
            if (this.childListObserver) {
                this.childListObserver.disconnect();
                this.childListObserver = null;
            }
        }
    };
}

// @ts-nocheck
function init(contextWindow) {
    const elementName = 'wow-image';
    contextWindow = contextWindow || window;
    if (contextWindow.customElements.get(elementName) === undefined) {
        let resizeObserver;
        if (contextWindow.ResizeObserver) {
            resizeObserver = new contextWindow.ResizeObserver((entries) => entries.map((entry) => entry.target.reLayout()));
        }
        let intersectionObserver;
        if (contextWindow.IntersectionObserver) {
            intersectionObserver = new IntersectionObserver((entries, observer) => entries.map((entry) => {
                if (entry.isIntersecting) {
                    const wowImage = entry.target;
                    wowImage.unobserveIntersect();
                    // resize Observe will invoke relayout imidiatly.
                    // "Observation will fire when observation starts if Element is being rendered, and Element’s size is not 0,0,"
                    // https://drafts.csswg.org/resize-observer/#dom-resizeobserver-observe
                    wowImage.observeResize();
                }
                return entry;
            }), { rootMargin: '50% 0px' });
        }
        return function (services, env) {
            const WowImage = wowImageFactory({
                resizeService: resizeObserver,
                intersectionService: intersectionObserver,
                ...services,
            }, env, contextWindow);
            contextWindow.customElements.define(elementName, WowImage);
        };
    }
    return;
}

const getDevicePixelRatio = () => {
    const isMSMobileDevice = /iemobile/i.test(navigator.userAgent);
    if (isMSMobileDevice) {
        return Math.round(window.screen.availWidth /
            (window.screen.width || window.document.documentElement.clientWidth));
    }
    return window.devicePixelRatio;
};
const STATIC_MEDIA_URL = 'https://static.wixstatic.com/media';
const MEDIA_ROOT_URL = 'https://static.wixstatic.com';
function initCustomElement(services = {}, contextWindow = null, envConsts = {}) {
    if (typeof window === 'undefined') {
        return;
    }
    const env = {
        staticMediaUrl: STATIC_MEDIA_URL,
        mediaRootUrl: MEDIA_ROOT_URL,
        experiments: {},
        devicePixelRatio: getDevicePixelRatio(),
        ...envConsts,
    };
    const define = init(contextWindow);
    if (define) {
        define({ mutationService: fastdom, ...services }, env);
    }
}

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
let wixImageInitialized = false;
const Image = (props) => {
  if (!wixImageInitialized) {
    initCustomElement();
    wixImageInitialized = true;
  }
  const _a = props, { containerProps, error } = _a, imageProps = __objRest(_a, ["containerProps", "error"]);
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      style: containerProps == null ? void 0 : containerProps.style,
      id: containerProps == null ? void 0 : containerProps.containerId,
      className: containerProps == null ? void 0 : containerProps.className,
      "data-hook": containerProps == null ? void 0 : containerProps.dataHook
    },
    /* @__PURE__ */ React__default.createElement(Image$1, __spreadValues({}, imageProps)),
    error && /* @__PURE__ */ React__default.createElement(MediaItemErrorMsg, { error: error.message, t: error.t })
  );
};

export { Image as default };
//# sourceMappingURL=Image.js.map
